import { BaseResponseDTO } from "./base.response.dto";

export class GetPermisosResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: Array<string>;

}
